const diagramColors = [
  'Aqua',
  'Aquamarine',
  'Bisque',
  'Blue',
  'Brown',
  'CadetBlue',
  'Chartreuse',
  'Chocolate',
  'Coral',
  'Gray',
  'Magenta',
  'Maroon',
  'MintCream',
  'Olive',
  'Plum',
  'RoyalBlue',
  'Yellow'
]

export default {
  methods: {
    getNextDiagramColor (i) {
      return diagramColors[i % diagramColors.length]
    }
  }
}
